/**
 * List of profane words in Portuguese (Brazil) to be filtered in chat communications
 * 
 * This list contains common profanities and offensive terms in Brazilian Portuguese.
 * The list is used to prevent admin users from sending inappropriate messages.
 */

const profanityList = [
  // Common profanities
  "porra",
  "caralho",
  "cacete",
  "foda",
  "fodeu",
  "fodase",
  "foda-se",
  "fodido",
  "merda",
  "bosta",
  "cagado",
  "cagada",
  "cagar",
  "bunda",
  "buceta",
  "boceta",
  "xoxota",
  "xereca",
  "piroca",
  "pinto",
  "rola",
  "pau",
  "pica",
  "cu",
  "cuzão",
  "cuzao",
  "curao",
  "burro",
  "idiota",
  "imbecil",
  "estúpido",
  "estupido",
  "babaca",
  "viado",
  "veado",
  "bicha",
  "sapatão",
  "sapatao",
  "puta",
  "putaria",
  "vadia",
  "vagabunda",
  "vagabundo",
  "retardado",
  "mongol",
  "mongoloide",
  "filho da puta",
  "fdp",
  "pqp",
  "vai tomar no cu",
  "vtnc",
  "vsf",
  "vai se foder",
  "arrombado",
  "corno",
  "cornudo",
  "chupa",
  "vai se fuder",
  "fuder",
  "fude",
  "fudido",
  "fudeu",
  "fufu",
  
  // Variations with common replacements to avoid filters
  "p0rra",
  "c4ralho",
  "f0da",
  "f0dase",
  "f0da-se",
  "m3rda",
  "b0sta",
  "c4gado",
  "b0ceta",
  "x0x0ta",
  "p1nto",
  "r0la",
  "p4u",
  "p1ca",
  "est*pido",
  "b4baca",
  "v14do",
  "v1ado",
  "b1cha",
  "put4",
  "v4dia",
  "v4g4bund4",
  "r3tardado",
  "v41 t0mar n0 cu",
  "vtnc",
  "arr0mbado",
  "c0rno",
  "ch*pa"
];

export default profanityList;